module.exports = __webpack_public_path__ + "static/media/logo.3ca0d846.png";